import { render, staticRenderFns } from "./addtools.vue?vue&type=template&id=a8f1e7de&scoped=true"
import script from "./addtools.vue?vue&type=script&lang=js"
export * from "./addtools.vue?vue&type=script&lang=js"
import style0 from "./addtools.vue?vue&type=style&index=0&id=a8f1e7de&prod&scoped=true&lang=css"
import style1 from "./addtools.vue?vue&type=style&index=1&id=a8f1e7de&prod&lang=css"
import style2 from "./addtools.vue?vue&type=style&index=2&id=a8f1e7de&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8f1e7de",
  null
  
)

export default component.exports